import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { common } from '@ocean/ui'

const { Scrollbars } = common

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  justify-content: space-between;
`

export const CustomScrollbars = styled(Scrollbars)`
  flex: 1 1 auto;
  height: 0;
`

export const Content = styled.div`
  position: relative;

  ${({ theme }) => `
    padding-right: ${theme.space.mobile.base};
  `}
`

export const FillContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1 1 auto;
  height: 0;
  min-height: 50vh;
`

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  button {
    width: 280px;
  }

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.base};

    > * {
      margin-top: ${theme.space.mobile.tiny};
    }
  `};

  ${({ theme }) => media.sm`
    margin-top: ${theme.space.desktop.base};
    
    > * {
      margin-top: ${theme.space.desktop.tiny};
    }

    button {
      width: 350px;
    }
  `};
`
